// simple metadata
var MetadataWeakMap = new WeakMap();
var defineMetadata = function (key, value) { return function (atom) {
    var metadataMap = MetadataWeakMap.get(atom);
    if (metadataMap)
        metadataMap.set(key, value);
    else
        metadataMap = new Map([[key, value]]);
    MetadataWeakMap.set(atom, metadataMap);
}; };
var getMetadata = function (key, atom) {
    var target = atom;
    while (target) {
        var metadataMap = MetadataWeakMap.get(target);
        if (!metadataMap) {
            target = Object.getPrototypeOf(target);
            continue;
        }
        var value = metadataMap.get(key);
        return value ? value : null;
    }
};
export { defineMetadata, getMetadata };
//# sourceMappingURL=metadata.js.map